import React, { useEffect, useMemo, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import UserAvatar from './UserAvatar'

const PLACEHOLDER = '/metronic/assets/media/avatars/blank.png'

/**
 * Campo de fotografía de usuario (subir / quitar / preview circular).
 */
export default function UserPhotoField({
    currentUrl,
    file,
    removePhoto,
    onFileChange,
    onRemoveToggle,
    error,
    disabled = false,
}) {
    const inputRef = useRef(null)
    const [localPreview, setLocalPreview] = useState(null)

    useEffect(() => {
        if (!file) {
            setLocalPreview(null)
            return
        }
        const url = URL.createObjectURL(file)
        setLocalPreview(url)
        return () => URL.revokeObjectURL(url)
    }, [file])

    const displayUrl = useMemo(() => {
        if (removePhoto && !file) {
            return PLACEHOLDER
        }
        if (localPreview) {
            return localPreview
        }
        return currentUrl || PLACEHOLDER
    }, [removePhoto, file, localPreview, currentUrl])

    const hasStoredPhoto = Boolean(currentUrl && currentUrl !== PLACEHOLDER && !currentUrl.includes('blank.png'))

    const clearInput = () => {
        if (inputRef.current) {
            inputRef.current.value = ''
        }
    }

    return (
        <div className="d-flex flex-wrap align-items-center gap-4">
            <UserAvatar src={displayUrl} size={88} alt="Fotografía" />
            <div className="flex-grow-1" style={{ minWidth: '220px' }}>
                <Form.Label className="fw-bold">Fotografía</Form.Label>
                <Form.Control
                    ref={inputRef}
                    type="file"
                    accept="image/jpeg,image/png,image/webp,image/gif"
                    disabled={disabled}
                    onChange={(e) => {
                        const next = e.target.files?.[0] || null
                        onFileChange(next)
                    }}
                    isInvalid={!!error}
                />
                <Form.Text className="text-muted d-block mt-1">
                    Máximo 3 MB. Se convertirá a JPG (máx. 400px de ancho).
                </Form.Text>
                {error && <div className="invalid-feedback d-block">{error}</div>}
                <div className="mt-2 d-flex flex-wrap gap-2">
                    {(hasStoredPhoto || file) && !removePhoto && (
                        <Button
                            type="button"
                            size="sm"
                            variant="light-danger"
                            disabled={disabled}
                            onClick={() => {
                                clearInput()
                                onRemoveToggle(true)
                            }}
                        >
                            Quitar fotografía
                        </Button>
                    )}
                    {removePhoto && (
                        <Button
                            type="button"
                            size="sm"
                            variant="light"
                            disabled={disabled}
                            onClick={() => onRemoveToggle(false)}
                        >
                            Conservar fotografía actual
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}
